// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none,ts_nocheck=true"
// @generated from file pull_requests/v1/labels.proto (package github.pull_requests.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file pull_requests/v1/labels.proto.
 */
export const file_pull_requests_v1_labels: GenFile = /*@__PURE__*/
  fileDesc("Ch1wdWxsX3JlcXVlc3RzL3YxL2xhYmVscy5wcm90bxIXZ2l0aHViLnB1bGxfcmVxdWVzdHMudjEiSwoOTGFiZWxzUmVzcG9uc2USOQoGbGFiZWxzGAEgAygLMikuZ2l0aHViLnB1bGxfcmVxdWVzdHMudjEuUHVsbFJlcXVlc3RMYWJlbCJhChBQdWxsUmVxdWVzdExhYmVsEgoKAmlkGAEgASgDEgwKBG5hbWUYAiABKAkSDQoFY29sb3IYAyABKAkSEwoLZGVzY3JpcHRpb24YBCABKAkSDwoHbm9kZV9pZBgFIAEoCWIGcHJvdG8z");

/**
 * Response payload for
 * GET /:owner/:repo/pull/:number/page_data/labels
 *
 * Defined by PullRequests::PageData::SharedController#labels.
 *
 * @generated from message github.pull_requests.v1.LabelsResponse
 */
export type LabelsResponse = Message<"github.pull_requests.v1.LabelsResponse"> & {
  /**
   * @generated from field: repeated github.pull_requests.v1.PullRequestLabel labels = 1;
   */
  labels: PullRequestLabel[];
};

/**
 * Describes the message github.pull_requests.v1.LabelsResponse.
 * Use `create(LabelsResponseSchema)` to create a new message.
 */
export const LabelsResponseSchema: GenMessage<LabelsResponse> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_labels, 0);

/**
 * Named `PullRequestLabel` rather than `Label` to avoid colliding with the
 * minimal `Label` (name + color only) already defined in timeline.proto;
 * message names share the `github.pull_requests.v1` package namespace.
 *
 * @generated from message github.pull_requests.v1.PullRequestLabel
 */
export type PullRequestLabel = Message<"github.pull_requests.v1.PullRequestLabel"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string color = 3;
   */
  color: string;

  /**
   * Label description; absent when the legacy JSON value is null or empty.
   *
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * Global relay / GraphQL node id; used by the sidebar label picker for selection and diffing.
   *
   * @generated from field: string node_id = 5;
   */
  nodeId: string;
};

/**
 * Describes the message github.pull_requests.v1.PullRequestLabel.
 * Use `create(PullRequestLabelSchema)` to create a new message.
 */
export const PullRequestLabelSchema: GenMessage<PullRequestLabel> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_labels, 1);

import { registerSchemaHash } from "../../../schema-hash-registry";
registerSchemaHash(LabelsResponseSchema, "d11ea9ecacb6")
registerSchemaHash(PullRequestLabelSchema, "81194c52e140")
